import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_SHIFT = "identity-service/identity/shifts";

const RESOURCES = {
	PAGINATED_SHIFTS: (page, searchText, clientId, orderBy) =>
		`${BASE_SHIFT}/organizations/${clientId}/paginated?page=${page}&limit=8` +
		`&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	LIST_SHIFTS: () => `${BASE_SHIFT}`,
	GET_SHIFT: (id) => `${BASE_SHIFT}/${id}/s`,
	CREATE_SHIFT: () => `${BASE_SHIFT}`,
	UPDATE_SHIFT: (id) => `${BASE_SHIFT}/${id}`,
	DELETE_SHIFT: (id) => `${BASE_SHIFT}/${id}`,
	GET_SUMMARY: (clientId) => `${BASE_SHIFT}/organizations/${clientId}/summary`,
};

class ShiftService {
	static async getPaginatedShifts(page, searchText, clientId, orderBy) {
		try {
			return await axios.get(
				RESOURCES.PAGINATED_SHIFTS(page, searchText, clientId, orderBy),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar turnos paginados",
			});
			return error.response;
		}
	}

	static async listShifts() {
		try {
			return await axios.get(RESOURCES.LIST_SHIFTS());
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar turnos",
			});
			return error.response;
		}
	}

	static async getShift(id) {
		try {
			return await axios.get(RESOURCES.GET_SHIFT(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao buscar turno",
			});
			return error.response;
		}
	}

	static async createShift(payload) {
		try {
			const response = await axios.post(RESOURCES.CREATE_SHIFT(), payload);
			ResponseAlerts({
				response,
				successMessage: "Turno criado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar turno",
			});
			return error.response;
		}
	}

	static async updateShift(id, payload) {
		try {
			const response = await axios.put(RESOURCES.UPDATE_SHIFT(id), payload);
			ResponseAlerts({
				response,
				successMessage: "Turno atualizado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao atualizar turno",
			});
			return error.response;
		}
	}

	static async deleteShift(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_SHIFT(id));
			ResponseAlerts({
				response,
				successMessage: "Turno removido com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao remover turno",
			});
			return error.response;
		}
	}

	static async getShiftsSummary(clientId) {
		try {
			return await axios.get(RESOURCES.GET_SUMMARY(clientId));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao obter resumo dos turnos",
			});
			return error.response;
		}
	}
}

export default ShiftService;
